import React from 'react';
import usePublications from '../../../src/hooks/usePublications/usePublications';
import VideoTrack from '../VideoTrack/VideoTrack';
import useTrack from '../../../src/hooks/useTrack/useTrack';
import { useVideoContext } from '../../main';
import ScreenPlaceHolder from '../ScreenShare/PlaceHolder';
import { DNABox, DNAText } from '@alucio/lux-ui';
const SharingParticipantBadge = (props) => {
    var _a, _b;
    if (!props.participant)
        return null;
    return (React.createElement(DNABox, { alignX: "center", alignY: "center" },
        React.createElement(DNABox, { style: { backgroundColor: 'rgba(38, 172, 138, 1)', marginVertical: 1, paddingHorizontal: 8 } },
            React.createElement(DNAText, { style: { color: 'white' } },
                "You are viewing ",
                `${(_b = (_a = props.participant) === null || _a === void 0 ? void 0 : _a.identity) === null || _b === void 0 ? void 0 : _b.split('.')[2]}'s`,
                " screen"))));
};
function VideoPublication({ publication }) {
    const track = useTrack(publication);
    if (!track)
        return null;
    return (React.createElement(DNABox, { fill: true },
        React.createElement(VideoTrack, { track: track, priority: "high", customStyle: { objectFit: 'contain', width: '100%', height: '100%', maxWidth: undefined } })));
}
export default function ScreenShareTracks({ participant, onStopShare }) {
    const { room } = useVideoContext();
    const publications = usePublications(participant);
    const isLocal = participant === room.localParticipant;
    if (isLocal) {
        return (React.createElement(DNABox, { fill: true, alignX: "center", alignY: "center" },
            React.createElement(ScreenPlaceHolder, { onStopShare: onStopShare })));
    }
    let filteredPublication;
    if (publications.some(p => p.trackName.includes('screen'))) {
        filteredPublication = publications.find(p => p.trackName.includes('screen'));
        return (React.createElement(DNABox, { fill: true, appearance: "col" },
            React.createElement(SharingParticipantBadge, { participant: participant }),
            React.createElement(VideoPublication, { publication: filteredPublication })));
    }
    else {
        return null;
    }
}
//# sourceMappingURL=ShareScreen.js.map